export function array2Object<T, K extends keyof T>(
  items: T[],
  key: K = 'id' as K
): Record<string | number, T> {
  return items.reduce((acc: Record<string | number, T>, item: T) => {
    const keyValue: T[K] = item[key];
    if (typeof keyValue === 'string' || typeof keyValue === 'number') {
      acc[keyValue] = item;
    }

    return acc;
  }, {});
}

export function array2ObjectArray<T, K extends keyof T>(
  items: T[],
  key: K = 'id' as K
): Record<number, T[]> {
  return items.reduce((acc: Record<number, T[]>, item: T) => {
    const keyValue: T[K] = item[key];

    if (typeof keyValue === 'number') {
      if (!acc[keyValue]) {
        acc[keyValue] = [];
      }

      acc[keyValue].push(item);
    }

    return acc;
  }, {});
}

export function object2Array<T extends object>(items: T): T[keyof T] {
  return Object.values(items).flat() as T[keyof T];
}
